import { FullPageCard } from "../FullPageCard/FullPageCard";

export const GlobalErrorPage = () => {
  return (
    <div className="flex w-full">
      <div className="flex w-full">
        <FullPageCard
          title="Something went wrong"
          backButtonLink="/"
          backButtonTitle="Back to home"
        >
          <div>
            {`There was an error fetching this page. The server admin has been notified. Please try again later.`}
          </div>
        </FullPageCard>
      </div>
    </div>
  );
};
